export default "__VITE_ASSET__BT8TxlJB__"